<template>
  <router-link :to="to" class="shortcut-card">
    <div class="shortcut-card__icon">
      <slot name="icon">
        <b-icon-lightning />
      </slot>
    </div>
    <div class="shortcut-card__content">
      <strong>{{ title }}</strong>
      <span>{{ description }}</span>
    </div>
    <span class="shortcut-card__action" aria-hidden="true">
      <b-icon-chevron-right />
    </span>
  </router-link>
</template>

<script>
export default {
  name: "DashboardShortcutCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    to: {
      type: [String, Object],
      required: true,
    },
  },
};
</script>

<style scoped>
.shortcut-card {
  min-height: 128px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  padding: 20px;
  border: 1px solid rgba(72, 50, 136, 0.08);
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfaff 100%);
  color: #100f53;
  text-decoration: none;
  transition: transform 0.2s ease, border-color 0.2s ease;
}

.shortcut-card:hover {
  color: #100f53;
  text-decoration: none;
  border-color: rgba(99, 54, 231, 0.28);
  transform: translateY(-2px);
}

.shortcut-card__icon {
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: #4b20ce;
  font-size: 34px;
  background: #f1ecff;
}

.shortcut-card__content {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.shortcut-card__content strong {
  font-size: 14px;
  line-height: 1.2;
  overflow-wrap: normal;
}

.shortcut-card__content span {
  color: #77739a;
  font-size: 11px;
  line-height: 1.55;
  max-width: 180px;
  overflow-wrap: normal;
}

.shortcut-card__action {
  width: 28px;
  height: 28px;
  align-self: end;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #ffffff;
  background: #3f18b5;
}

@media screen and (max-width: 1500px) {
  .shortcut-card {
    min-height: 112px;
    padding: 18px;
  }

  .shortcut-card__content span {
    max-width: none;
  }
}

@media screen and (max-width: 700px) {
  .shortcut-card {
    min-height: auto;
  }
}
</style>
